import React, { useEffect, useState } from "react";
import { api } from "../../../../resources/api";
import { connect } from "react-redux/es/exports";
import Loader from "../../../common/loader/loader";
import AGTable from "../../../common/table/AGTable";
import { toast } from "react-toastify";
import { showAlert, showConfirm } from "../../../common/sweetalert/sweetalert";
import PageHeader from "../../../common/pageheader/pageheader";
import Modal from "../../../common/modal/modal";
import SearchSelect from "../../../common/select/SearchSelect";

function FinanceAllowRegistration(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [allSemester, setAllSemester] = useState([]);
    const [selectedSemester, setSelectedSemester] = useState("");
    const [allowModal, setAllowModal] = useState({
        student: null,
        actionType: "",
        semesterCode: "",
        requestBy: "",
    });
    const [studentDatatable, setStudentDatatable] = useState({
        columns: [
            { label: "S/N", field: "sn" },
            { label: "Student ID", field: "StudentID" },
            { label: "First Name", field: "FirstName" },
            { label: "Surname", field: "Surname" },
            { label: "Middle Name", field: "MiddleName" },
            { label: "Student Level", field: "StudentLevel" },
            { label: "Student Semester", field: "StudentSemester" },
            { label: "Course Name", field: "CourseName" },
            { label: "Unblock", field: "unblock" },
            { label: "Unblock Request", field: "unblockRequest" },
        ],
        rows: [],
    });

    const semesterOptions = allSemester.map((s) => ({
        value: s.SemesterCode,
        label: s.SemesterName ? `${s.SemesterName} (${s.SemesterCode})` : s.SemesterCode,
    }));

    const openAllowModal = (student, actionType) => {
        setAllowModal({
            student,
            actionType,
            semesterCode: selectedSemester,
            requestBy: "",
        });
    };

    const closeAllowModal = () => {
        setAllowModal({
            student: null,
            actionType: "",
            semesterCode: "",
            requestBy: "",
        });
    };

    const onAllowModalChange = (field, value) => {
        setAllowModal((prev) => ({ ...prev, [field]: value }));
    };

    const getStudentName = (student) => `${student?.FirstName || ""} ${student?.MiddleName || ""} ${student?.Surname || ""}`.trim();

    const getData = async (semesterCode) => {
        const semester = semesterCode || selectedSemester;
        if (!semester) return;

        setIsLoading(true);
        const { success, data } = await api.get(`staff/student-manager/finance/registration/clearance/${semester}`);
        if (success && data && data.length > 0) {
            let rows = [];
            data.map((item, index) => {
                rows.push({
                    sn: index + 1,
                    StudentID: item.StudentID,
                    FirstName: item.FirstName,
                    MiddleName: item.MiddleName,
                    Surname: item.Surname,
                    StudentLevel: item.StudentLevel,
                    StudentSemester: item.StudentSemester.replace("Semester", ""),
                    CourseName: item.CourseName,
                    unblock: (
                        <button className="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#allowRegistrationSemesterModal" onClick={() => openAllowModal(item, "direct")}> Unblock <i className="fa fa-unlock" /></button>
                    ),
                    unblockRequest: (
                        <button className="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#allowRegistrationSemesterModal" onClick={() => openAllowModal(item, "request")}> Unblock Request <i className="fa fa-send" /></button>
                    ),
                });
            });
            setStudentDatatable({
                ...studentDatatable,
                rows: rows,
            });
        } else {
            setStudentDatatable({
                ...studentDatatable,
                rows: [],
            });
        }
        setIsLoading(false);
    };

    useEffect(() => {
        const getSchoolSemester = async () => {
            try {
                const { success, data } = await api.get("staff/timetable/timetable/semester");
                if (success) {
                    const semesters = (data || []).filter((semester) => semester.Status !== "future");
                    setAllSemester(semesters);
                    if (semesters.length > 0) {
                        setSelectedSemester(semesters[0].SemesterCode);
                        getData(semesters[0].SemesterCode);
                    } else {
                        setIsLoading(false);
                    }
                }
            } catch (ex) {
                console.error(ex);
                setIsLoading(false);
            }
        };
        getSchoolSemester();
    }, []);

    const submitAllowRegistration = async () => {
        const student = allowModal.student;
        if (!student) return;
        if (!allowModal.semesterCode) {
            showAlert("EMPTY FIELD", "Please select the semester", "error");
            return;
        }
        if (allowModal.actionType === "request" && !allowModal.requestBy.trim()) {
            showAlert("EMPTY FIELD", "Please enter the StaffID", "error");
            return;
        }

        const selectedSemesterLabel = semesterOptions.find((s) => s.value === allowModal.semesterCode)?.label || allowModal.semesterCode;
        const studentName = getStudentName(student);
        const actionLabel = allowModal.actionType === "request" ? "send an unblock request" : "unblock";
        const isConfirmed = await showConfirm(
            "CONFIRM UNBLOCKING",
            `Are you sure you want to ${actionLabel} ${studentName} for Registration in ${selectedSemesterLabel}?`,
            "warning"
        );

        if (!isConfirmed) return;

        let sendData = {
            StudentID: student.StudentID,
            FirstName: student.FirstName,
            MiddleName: student.MiddleName,
            Surname: student.Surname,
            CourseCode: student.CourseCode,
            CourseName: student.CourseName,
            StudentLevel: student.StudentLevel,
            StudentSemester: student.StudentSemester,
            EmailAddress: student.EmailAddress,
            InsertedBy: props.LoginDetails[0].StaffID,
            RequestBy: allowModal.actionType === "request" ? allowModal.requestBy.trim() : "",
            SemesterCode: allowModal.semesterCode,
        };

        setIsSubmitting(true);
        const { success, data } = await api.post("staff/finance/allow-student-registration", sendData);
        setIsSubmitting(false);

        if (success && data.message === "success") {
            getData();
            toast.success(allowModal.actionType === "request" ? "Request Sent Successfully" : "Registration Access Granted Successfully");
            document.getElementById("closeAllowRegistrationModal")?.click();
            closeAllowModal();
        } else {
            showAlert(
                "ERROR",
                "Something went wrong. Please try again!",
                "error"
            );
        }
    };

    return isLoading ? (
        <Loader />
    ) :
        (
            <>
                <div className="card" style={{ borderStyle: 'none', borderWidth: '0px', width: '100%' }}>
                    <div className="">
                        <PageHeader
                            title={"FINANCE UNBLOCK STUDENT REGISTRATION"}
                            items={["Human-Resources", "Finance", "Finance Unblock Student Registration"]}
                        />
                        <div className="row col-md-12 mb-5">
                            <div className="col-md-4">
                                <label className="fs-6 fw-bold mb-2">Select Semester</label>
                                <select
                                    className="form-control"
                                    value={selectedSemester}
                                    onChange={(e) => {
                                        setSelectedSemester(e.target.value);
                                        getData(e.target.value);
                                    }}
                                >
                                    <option value="">Select Semester</option>
                                    {allSemester.map((s) => (
                                        <option key={s.SemesterCode} value={s.SemesterCode}>
                                            {s.SemesterName || s.SemesterCode}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="row col-md-12" style={{ width: '100%' }}>
                            <AGTable data={studentDatatable} />
                        </div>
                    </div>

                </div>
                <Modal title={allowModal.actionType === "request" ? "Request Registration Access" : "Allow Registration Access"} id="allowRegistrationSemesterModal" close="closeAllowRegistrationModal" onClose={closeAllowModal}>
                    <div className="row">
                        <div className="col-md-12 mb-5">
                            <label className="fs-6 fw-bold mb-2">Student</label>
                            <input className="form-control" value={allowModal.student ? `${getStudentName(allowModal.student)} - ${allowModal.student.StudentID}` : ""} readOnly />
                        </div>
                        <div className="col-md-12 mb-5">
                            <SearchSelect
                                id="allowRegistrationSemesterCode"
                                label="Select Semester"
                                value={semesterOptions.find((s) => s.value === allowModal.semesterCode) || null}
                                options={semesterOptions}
                                onChange={(selected) => onAllowModalChange("semesterCode", selected?.value || "")}
                                placeholder="Select semester"
                                required
                            />
                        </div>
                        {allowModal.actionType === "request" && (
                            <div className="col-md-12 mb-5">
                                <label className="fs-6 fw-bold mb-2">Requesting StaffID</label>
                                <input
                                    className="form-control"
                                    value={allowModal.requestBy}
                                    onChange={(e) => onAllowModalChange("requestBy", e.target.value)}
                                    placeholder="Enter StaffID"
                                />
                            </div>
                        )}
                        <div className="col-md-12">
                            <button type="button" className="btn btn-primary w-100" onClick={submitAllowRegistration} disabled={isSubmitting} data-kt-indicator={isSubmitting ? "on" : "off"}>
                                <span className="indicator-label">Submit</span>
                                <span className="indicator-progress">Please wait...<span className="spinner-border spinner-border-sm align-middle ms-2" /></span>
                            </button>
                        </div>
                    </div>
                </Modal>
            </>
        );
}


const mapStateToProps = (state) => {
    return {
        LoginDetails: state.LoginDetails,
    };
};
export default connect(mapStateToProps, null)(FinanceAllowRegistration);
